export const TEXT = 'text'
export const NUMBER = 'number'
export const EMAIL = 'email'
